import { useL10n } from '@uplift/hooks';
import { FormikProps } from 'formik';
import { useCallback } from 'react';
import { CancelSessionForm, ModalStep } from '../types';
import { Button } from '../../../../Button';
import { ArrowForward } from '@mui/icons-material';

export type NextActionProps = {
  step: ModalStep;
  formik: FormikProps<CancelSessionForm>;
  onNextStep: () => void;
};

export const NextAction: React.VFC<NextActionProps> = ({ step, formik, onNextStep }) => {
  const l10n = useL10n();

  const getValid = useCallback(() => {
    if (step === 'session') {
      return formik.values.recurring !== null;
    }

    if (step === 'reason') {
      return formik.values.cancelationReason !== null;
    }

    return formik.isValid;
  }, [ formik.isValid, formik.values.cancelationReason, formik.values.recurring, step ]);

  if (step === 'note') {
    return (
      <Button
        variant="contained"
        color="error"
        loading={formik.isSubmitting}
        onClick={formik.handleSubmit}
        disabled={!getValid()}
      >
        {l10n.schedule.cancelAppointment.cancel(formik.values.recurring === 'all')}
      </Button>
    );
  }

  return (
    <Button
      variant="contained"
      color="secondary"
      loading={formik.isSubmitting}
      onClick={onNextStep}
      disabled={!getValid()}
      endIcon={<ArrowForward />}
    >
      {l10n.navigation.next}
    </Button>
  );
};
